/** Resolve a wall-clock selection in the chosen IANA zone. Do not silently pick
 * one side of a daylight-saving gap or repeated local hour. */
export function academicInstant(local: string, timezone: string): string {
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(local)) throw new Error("Choose a complete date and time.");
  const nominal = Date.parse(local + ":00Z");
  if (!Number.isFinite(nominal) || new Date(nominal).toISOString().slice(0, 16) !== local)
    throw new Error("Choose a valid calendar date.");
  const formatter = new Intl.DateTimeFormat("en-CA", {
    timeZone: timezone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  });
  const wall = (instant: number) => {
    const parts = Object.fromEntries(formatter.formatToParts(instant).map(part => [part.type, part.value]));
    return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
  };
  const candidates = new Set<number>();
  for (const days of [-2, -1, 0, 1, 2]) {
    const probe = nominal + days * 86400000;
    const offset = Date.parse(wall(probe) + ":00Z") - probe;
    const candidate = nominal - offset;
    if (wall(candidate) === local) candidates.add(candidate);
  }
  if (candidates.size !== 1)
    throw new Error(
      "This time is missing or repeated in the selected time zone. Choose an unambiguous time, or enter the exact UTC time using UTC.",
    );
  return new Date([...candidates][0]).toISOString();
}
